export default {"src":"/_next/static/media/app-store.6a98ab09.svg","height":40,"width":120,"blurWidth":0,"blurHeight":0};